import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { map } from 'rxjs/operators';
import { IResult } from 'app/shared/models/result.model';
import { IDtoRelocation } from 'app/shared/models/request/relocation/dto-relocation.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoFilter } from 'app/shared/models/filter.model';

@Injectable()
export class RelocationService {
    private requestUrl = '';
    private openingUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
            this.openingUrl = this.configurationService.serverSettings.openingUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
                this.openingUrl = this.configurationService.serverSettings.openingUrl;
            });
        }
    }
    public getCatalogRelocationReasons(): Observable<IDtoCatalog[]> {
        const url = `${this.requestUrl}api/RelocationReasons/getCatalogRelocationReasons/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addRelocation(dto: IDtoRelocation): Observable<IResult> {
        const url =`${this.requestUrl}api/Relocations/addRelocation`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogRequisitions(codeNomCompanyPay: string, codeNomCustomer: string): Observable<ISelect[]> {
        const url = `${this.openingUrl}api/Requisitions/getCatalogRequisitionsByCompanyPayAndCustomer?codeNomCompanyPay=${codeNomCompanyPay}&codeNomCustomer=${codeNomCustomer}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getRelocations(data: IDtoFilter): Observable<IResult> {
        const url =`${this.requestUrl}api/Relocations/getRelocations/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
}
